import * as React from 'react'
import {Component, Fragment} from 'react'
import {findDOMNode} from 'react-dom'

///////////////////////////////////////////////////////////////////////////////

export type TextareaWrapperProps = {
  children?: any
}

///////////////////////////////////////////////////////////////////////////////

export class TextareaWrapper extends Component<TextareaWrapperProps, any> {
  private textarea: HTMLTextAreaElement
  private formBlock: HTMLElement

  constructor(props) {
    super(props)

    this.onInput = this.onInput.bind(this)
  }

  componentDidMount() {
    this.textarea = findDOMNode(this) as HTMLTextAreaElement
    this.formBlock = this.textarea.closest('.form-block') as HTMLElement

    let {textarea, formBlock, onInput} = this

    if (textarea) {
      textarea.addEventListener('input', onInput)

      if (formBlock) {
        formBlock.classList.add('textarea-wrapper')
      }
    }
  }

  componentWillUnmount() {
    let {textarea, onInput} = this

    if (textarea) {
      textarea.removeEventListener('input', onInput)
    }
  }

  onInput() {
    let {textarea} = this

    textarea.style.cssText = 'height: auto;'
    textarea.style.cssText = `height: ${textarea.scrollHeight}px;`
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>
  }
}
